export const GENDERS = {
  1: "Female",
  2: "Male",
};
